import { Button, Group, Paper, Space, Text } from '@mantine/core'
import { modals } from '@mantine/modals';
import { arrayUnion, collection, doc, updateDoc } from 'firebase/firestore';
import { useContext, useEffect, useMemo, useState } from 'react'
import { Agreement, AvailableAgreements, BaseResult, Customer, SendAgreementSMSRequest, UploadFileResult, UserDataType } from '../types';
import { httpsCallable } from 'firebase/functions';
import { useFirestore, useFunctions } from '../helpers/firebaseContext';
import { showNotification } from '@mantine/notifications';
import { IconCheck, IconX } from '@tabler/icons-react';
import { MyUserDataContext } from '../contexts';
import { UploadBox } from './upload_box';
import { FileRejection, FileWithPath } from '@mantine/dropzone';
import { fileHasKFHConsentTag, uploadToStorage } from '../helpers/uploadToStorage';

import { FilesList } from './files';



export interface AskForConsentProps {
    customerData: Customer;
}


const AskForConsent = ({ customerData }: AskForConsentProps) => {
    const [uploading, setUploading] = useState(false);
    const [consentUploaded, setConsentUploaded] = useState(false);
    const [links, setLinks] = useState([] as any[]);
    const [forceRefreshFiles, setForceRefreshFiles] = useState<number | null>()

    const functions = useFunctions();
    functions.region = "europe-west1";
    const db = useFirestore();

    const userData: UserDataType = useContext(MyUserDataContext);
    // let userClaims = userData.firebaseTokenResult?.claims.customClaims as CustomClaims || {};


    const [pendingAskForConsent, setPendingAskForConsent] = useState<boolean>(false);
    const sendAgreementSMS = httpsCallable<SendAgreementSMSRequest, BaseResult>(functions, "sendAgreementSMS");
    const checkConsentUploaded = async () => {
        const isConsentUploaded = await fileHasKFHConsentTag(('agreements/consent/' + customerData.id));
        console.log("isConsentUploaded =======>", isConsentUploaded);

        setConsentUploaded(isConsentUploaded);
    }
    useEffect(() => {

        checkConsentUploaded();
    }, [customerData])
    const handleDownload = async () => {
        const response = await fetch(
            'https://storage.googleapis.com/public-pdfs/%D8%AA%D9%81%D9%88%D9%8A%D8%B6%20%D8%A8%D9%8A%D8%AA%20%D8%A7%D9%84%D8%AA%D9%85%D9%88%D9%8A%D9%84%20%D8%A7%D9%84%D9%83%D9%88%D9%8A%D8%AA%D9%8A.pdf'
        );
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'تفويض بيت التمويل الكويتي.pdf';
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
    };

    const showConsentFiles = useMemo(() => <>
        <Space h={"sm"} />
        {consentUploaded && <FilesList
            disableDelete={true}
            forceRefresh={forceRefreshFiles}
            setMetaTypes={() => { }}
            path={'agreements/' + customerData.id}
            showUploader={false}
            links={[]}
            setLinks={function (links: any[]): void {
                setLinks(links)
            }} />}

    </>
        , [consentUploaded, forceRefreshFiles, customerData.id])
    return (

        <Paper shadow="xs" p="md">
            <Text>
                The client has not yet agreed to allow you to access their investment information.  Please ask for consent before proceeding.
            </Text>
            <Space h="xs" />



            <Group>

                <Button
                    color="yellow"
                    loading={pendingAskForConsent}
                    type="button"
                    name="ask_for_consent"
                    onClick={async () => {

                        modals.openConfirmModal({
                            title: 'Please confirm your action',
                            children: (
                                <Text size="sm">
                                    I acknowledge that all the data and information related to the client, as specified in the authorization, are considered confidential and protected under the laws, regulatory instructions, and systems in force at Kuwait Finance House Group. It is prohibited to disclose or use such information for purposes other than those authorized by the client and for their benefit. I commit to protecting Kuwait Finance House Group from any losses, damages, or expenses that may arise from my misconduct, intentional actions, negligence, or failure to comply with the rules, laws, and systems in place regarding the protection of client information confidentiality.
                                </Text>
                            ),
                            labels: { confirm: 'Ask for Consent', cancel: 'Cancel' },
                            confirmProps: { loading: pendingAskForConsent },
                            onCancel: () => console.log('Cancel'),
                            onConfirm: async () => {
                                //send API request to create AMS
                                setPendingAskForConsent(true);
                                try {
                                    //generate a doc ID
                                    const docID = doc(collection(db, "sms")).id;

                                    //maybe this agreement should be in firestore somewhere.
                                    const agreement: Agreement = {
                                        customerObj: customerData,
                                        agreement_id: AvailableAgreements.kfh_rm_access_consent,
                                        title_en: "KFH Consent",
                                        title_ar: "تفويض لبيت التمويل الكويتي",
                                        content_en: "I agree to award Kuwait Finance House the right to view all information and data related to my investments with (KFH Capital Investment Company)",
                                        content_ar: "أوافق على منح بيت التمويل الكويتي حق الإطلاع على جميع المعلومات والبيانات الخاصة بإستثماراتى لدى (شركة بيتك كابيتال للإستثمار)",
                                        paci_msg_en: "Agreeing to grant KFH access to my investment data with KFH Capital.",
                                        paci_msg_ar: "الموافقة على منح بيت التمويل الكويتي حق الإطلاع على بيانات استثماراتي لدى بيتك كابيتال."
                                    }

                                    const res = await sendAgreementSMS({
                                        agreement: agreement,
                                        token: await userData.getAzureADToken!(userData),
                                        smsDocID: docID,
                                    });

                                    showNotification({
                                        id: "consent",
                                        color: "green",
                                        icon: <IconCheck />,
                                        withBorder: true,
                                        message: `Consent request for customer ${customerData.name_en} sent to ${customerData.mobile}`,
                                        autoClose: true,
                                    });

                                    console.log("Result from sendAgreementSMS", res);
                                } catch (error: any) {
                                    showNotification({
                                        id: "error",
                                        color: "red",
                                        icon: <IconX />,
                                        withBorder: true,
                                        message: `Error asking for consent: ${error.message}`,
                                        autoClose: true,
                                    });

                                }
                                setPendingAskForConsent(false);
                            },
                        });
                    }}
                >
                    Ask for Consent
                </Button>


                {<>
                    <Button
                        // color="yellow"
                        loading={pendingAskForConsent}
                        disabled={consentUploaded}
                        type="button"
                        name="upload_consent"
                        onClick={async () => {

                            modals.open({
                                title: 'Please upload the consent form',
                                children: (
                                    <div>

                                        <UploadBox
                                            loading={uploading}
                                            label="Drag file here or click to select file"
                                            multiple={false}
                                            clearFiles={false}

                                            onDropAny={async (files, filesRejected: FileRejection[], setUploadedFiles, uploadedFiles?: FileWithPath[]) => {
                                                // form.setFieldValue("order.acct", "");
                                                // form.setFieldValue("order.iban", "");

                                                if (files?.length === 0) return;



                                                console.log("Files dropped!", files, filesRejected, uploadedFiles);

                                                setUploading(true);
                                                if (!files || files?.length === 0) return;

                                                let tags: Record<string, string> = {
                                                    "kfhConsent": "true",
                                                    "type": "kfh_consent"
                                                };

                                                await uploadToStorage(files[0], 'agreements/consent/' + customerData.id, tags);

                                                setUploading(false);
                                                showNotification({
                                                    id: "success",
                                                    color: "green",
                                                    icon: <IconX />,
                                                    withBorder: true,
                                                    message: `Consent Uploaded successfully, waiitng for approval`,
                                                    autoClose: true,
                                                });

                                                const consentCollectionRef = doc(db, "manual", "consent");
                                                updateDoc(consentCollectionRef, {
                                                    requires_approval: arrayUnion({
                                                        customerID: customerData.id,
                                                        customerName: customerData.name_en,
                                                        customerCivilID: customerData.civilID ?? customerData.commercial_register ?? null,
                                                        path: 'agreements/consent/' + customerData.id,
                                                    }),
                                                })
                                                setForceRefreshFiles(Math.random())
                                                checkConsentUploaded();
                                                modals.closeAll();

                                            }}
                                        />
                                    </div>
                                ),

                            });
                        }}
                    >
                        Upload Consent Form

                        {
                            consentUploaded && <Text>
                                {"  (Consent document already uploaded)"}
                            </Text>}
                    </Button>
                </>
                }


                <Button onClick={handleDownload}
                >
                    Download consent form
                </Button>


            </Group>
            {showConsentFiles}
        </Paper>

    )
}

export default AskForConsent